import React from "react";
import { InfoCircle } from "iconsax-react";

const DataNotFound = () => {
  return (
    <>
      <div className="flex flex-col items-center justify-center h-96 sm:h-[350px] md:h-[400px] lg:h-[450px] px-4">
        <InfoCircle size={28} color={"grey"} />
        <p className="mt-2 text-xl sm:text-lg md:text-xl lg:text-2xl font-normal text-center font-Proxima opacity-65">
          Data Not Found
        </p>
      </div>
    </>
  );
};

export default DataNotFound;
